// 扁平化
export function flatten(treeNodes, expandedKeys) {
  const expandedKeysSet = expandedKeys ? new Set(expandedKeys) : undefined
  const flattenedNodes = []
  function traverse(nodes) {
    for (const node of nodes) {
      flattenedNodes.push(node)
      if (node.isLeaf || !node.children) continue
      if (expandedKeysSet && !expandedKeysSet.has(node.key)) continue
      traverse(node.children || [])
    }
  }
  traverse(treeNodes)
  return flattenedNodes
}

export function contains(root, child) {
  const rootKey = root.key
  while (child) {
    if (child.key === rootKey) return true
    child = child.parent
  }
  return false
}

// 获取非叶子节点
export function getNonLeafKeys(treeNodes) {
  const nonLeafKeys = []
  const cb = (node) => {
    if (!node.isLeaf) nonLeafKeys.push(node.key)
    traverse(node.children || [])
  }
  function traverse(nodes) {
    for (const node of nodes) {
      cb(node)
    }
  }
  traverse(treeNodes)
  return nonLeafKeys
}

export function getPath(key, options, treeMap) {
  const { includeSelf = false } = options
  let node = treeMap.get(key)
  const pathRes = {
    keyPath: [],
    nodePath: [],
    node
  }

  while (node) {
    pathRes.nodePath.push(node)
    node = node.parent
  }
  pathRes.nodePath.reverse()
  if (!includeSelf) {
    pathRes.nodePath.pop()
  }
  pathRes.keyPath = pathRes.nodePath.map((node) => node.key)
  return pathRes
}

export function traverseWithCb(treeNode, callback) {
  const command = callback(treeNode)
  if (treeNode.children && command !== 'stop') {
    treeNode.children.forEach((child) => {
      traverseWithCb(child, callback)
    })
  }
}

export function merge(sourceKeys, targetKeys) {
  if (!sourceKeys) return targetKeys
  if (!targetKeys) return sourceKeys
  return [...new Set([...sourceKeys, ...targetKeys])]
}

export function minusKeys(sourceKeys, targetKeys) {
  if (!sourceKeys) return []
  if (!targetKeys) return sourceKeys
  return sourceKeys.filter((key) => !targetKeys.includes(key))
}



// WEBPACK FOOTER //
// ./src/layout/components/tree/tree-store/_util.js